@if (statusDot() !== 'none') {
  <span
    class="pill-status-dot"
    [class.pulse]="statusDot() === 'pulse'"
    aria-hidden="true"
  ></span>
}
@if (!hideIcon()) {
  <iris-icon
    class="pill-icon"
    [name]="icon()"
    [size]="iconSmallSize"
    [usage]="iconDecorativeUsage"
    [colorToken]="iconColorToken()"
  />
}
<span
  class="pill-text"
  [attr.data-test]="'pill-' + displayText()"
>
  {{ displayText() }}
</span>
